export const TableColumnTypes = {
  Actions: 0,
  Date: 1,
  Text: 2,
};
